import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const findAllPalishReceipt = createAsyncThunk(
  "PalishReceipt/FindAllPalishReceipt",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PalishReceipt/FindAllPalishReceipt`,
        formData,
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Palish Receipt", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createPalishReceipt = createAsyncThunk(
  "PalishReceipt/InsertPalishReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PalishReceipt/InsertPalishReceipt`,
        formdata,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create Palish Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePalishReceipt = createAsyncThunk(
  "PalishReceipt/UpdatePalishReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PalishReceipt/UpdatePalishReceipt`,
        formdata,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Palish Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePalishReceipt = createAsyncThunk(
  "PalishReceipt/DeletePalishReceipt",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PalishReceipt/DeletePalishReceipt`,
        { palish_receipt_guid: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Palish Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPalishReceiptById = createAsyncThunk(
  "PalishReceipt/FindByIDPalishReceipt",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PalishReceipt/FindByIDPalishReceipt`,
        { palish_receipt_guid: ID },
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        palish_receipt_guid: result.palish_receipt_guid,
        palish_receipt_no: result.palish_receipt_no,
        receipt_date: result.receipt_date
          ? moment(result.receipt_date).toDate()
          : "",

        karigar_id: result.karigar_id,
        karigar_name: result.karigar_name,
        karigar_nick_name: result.karigar_nick_name,
        charges: result.charges,
        gold_rate: result.gold_rate,
        palish_receipt_order: result?.palish_receipt_order,
        karigarIdWiseOutStandingAmount: result?.karigarIdWiseOutStandingAmount,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Palish Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePalishReceiptOrderItems = createAsyncThunk(
  "PalishReceipt/DeletePalishReceiptOrder",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PalishReceipt/DeletePalishReceiptOrder`,
        { id: ID },
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Palish Receipt Order item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePalishReceiptImage = createAsyncThunk(
  "PalishReceipt/PalishReceiptImageUpdate",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PalishReceipt/PalishReceiptImageUpdate`,
        formdata,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Palish Receipt Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findAllPendingPalishOrder = createAsyncThunk(
  "PalishReceipt/PalishPendingOrderList",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PalishReceipt/PalishPendingOrderList`,
        formData,
      );

      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Palish Receipt", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
